import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModuleTipuriProgramComponent } from './module-tipuri-program.component';
import { AddModuleTipuriProgramComponent } from './add-module-tipuri-program/add-module-tipuri-program.component';
import { EditModuleTipuriProgramComponent } from './edit-module-tipuri-program/edit-module-tipuri-program.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';

@NgModule({
    declarations: [
        ModuleTipuriProgramComponent,
        AddModuleTipuriProgramComponent,
        EditModuleTipuriProgramComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule
    ],
    exports: [ModuleTipuriProgramComponent],
})
export class ModuleTipuriProgramModule { }
